export enum GridSubAction {
  reload = 'reload',
  clearFilter = 'clear filter',
  resetFilter = 'reset filter',
  exportList = 'export list', // export displaying items
  exportAll = 'export all'  // backend makes all items list
}
